interface IconProps {
  className?: string;
}

const SVG_PROPS = {
  fill: 'none',
  stroke: 'currentColor',
  viewBox: '0 0 24 24',
  'aria-hidden': true,
} as const;

export function InfoIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} {...SVG_PROPS}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
}

export function PlusIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} {...SVG_PROPS}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
  );
}

export function ChevronLeftIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} {...SVG_PROPS}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
  );
}

export function ChevronDownIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} {...SVG_PROPS}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  );
}

export function TrashIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} {...SVG_PROPS}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
    </svg>
  );
}

export function UserIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} {...SVG_PROPS}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  );
}

export function ExchangeIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} {...SVG_PROPS}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M4 7h13l-3-3m3 3l-3 3M20 17H7l3 3m-3-3l3-3" />
    </svg>
  );
}

export function ChatIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={className} {...SVG_PROPS}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M21 12a8 8 0 01-11.6 7.14L4 20.5l1.4-4.6A8 8 0 1121 12z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M8.5 12h.01M12 12h.01M15.5 12h.01" />
    </svg>
  );
}

export function WhatsAppIcon({ className = 'w-4 h-4' }: IconProps) {
  return (
    <svg className={`${className} shrink-0`} fill="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.533 5.85L.057 23.535a.75.75 0 0 0 .916.928l5.803-1.524A11.938 11.938 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.853 0-3.587-.5-5.084-1.375l-.361-.214-3.742.981.998-3.648-.235-.374A9.963 9.963 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
    </svg>
  );
}
